import { CircularProgress } from "@mui/material"
import styles from "./Spinner.module.css"

const Spinner = () => {
  return (
    <div className={styles.spinner_container}>
      <CircularProgress />
    </div>
  )
}

export default Spinner
